import { useState } from 'react'
import { Globe } from '@digital-twins/design-system/icons'

import { cn } from '@/lib/utils'

import { faviconUrlForHostname } from './citationSource'

export interface SourceFaviconProps {
  hostname: string | null
  className?: string
}

/**
 * The publisher's favicon from its hostname (no page fetch). A failed load
 * falls back to the globe so a broken image never sits in a pill.
 */
export function SourceFavicon(props: SourceFaviconProps) {
  const { hostname, className } = props

  const [failedHostname, setFailedHostname] = useState<string | null>(null)

  const src = hostname ? faviconUrlForHostname(hostname) : null

  if (!src || (hostname !== null && failedHostname === hostname)) {
    return (
      <Globe
        className={cn('h-3.5 w-3.5 shrink-0 text-muted-foreground', className)}
        aria-hidden
        data-testid="source-favicon-fallback"
      />
    )
  }

  return (
    <img
      src={src}
      alt=""
      width={14}
      height={14}
      loading="lazy"
      referrerPolicy="no-referrer"
      className={cn('h-3.5 w-3.5 shrink-0 rounded-full', className)}
      data-testid="thread-web-source-card-favicon"
      onError={() => setFailedHostname(hostname)}

    />
  )
}
